import angular from 'angular';
import { IPastaEmpresa, IArquivoEmpresa } from '../model/arquivos.empresa.model';
import { NsjRoutingType } from '@core/nsj-core';

export class MeurhArquivosEmpresaService {
    static $inject = ['$http', '$rootScope', '$q', 'nsjRouting'];

    public loading_deferred: angular.IDeferred<unknown>;

    constructor(
        public $http: angular.IHttpService,
        public $rootScope: angular.IScope,
        public $q: angular.IQService,
        public nsjRouting: NsjRoutingType,
    ) { }

    getPastas() {
        this.loading_deferred = this.$q.defer();
        return this.$q<IPastaEmpresa[]>((resolve, reject) => {
            this.$http.get<IPastaEmpresa[]>(
                this.nsjRouting.generate('meurh_tiposarquivosempresas_index', {}, true),
                { timeout: this.loading_deferred.promise }
            )
            .then((response) => {
                this.$rootScope.$broadcast('meurh_tiposarquivosempresas_index_loaded', response.data);
                resolve(response.data);
            })
            .catch((error) => reject(error));
        });
    }

    getArquivos(tipoarquivoempresa: string) {
        this.loading_deferred = this.$q.defer();
        return this.$q<IArquivoEmpresa[]>((resolve, reject) => {
            this.$http.get<IArquivoEmpresa[]>(
                this.nsjRouting.generate('meurh_arquivosempresas_index', {
                    tipoarquivoempresa
                }, true),
                { timeout: this.loading_deferred.promise }
            )
            .then((response) => {
                this.$rootScope.$broadcast('meurh_arquivosempresas_index_loaded', response.data);
                resolve(response.data);
            })
            .catch((error) => reject(error));
        });
    }

    getConteudo(id: string) {
        this.loading_deferred = this.$q.defer();
        return this.$q<angular.IHttpResponse<File>>((resolve, reject) => {
            this.$http.get<File>(
                this.nsjRouting.generate('meurh_arquivosempresas_get_arquivo', {
                    id
                }, true), {
                responseType: 'blob',
                timeout: this.loading_deferred.promise
            })
            .then((response) => {
                this.$rootScope.$broadcast('meurh_arquivosempresas_get_arquivo_loaded', response);
                resolve(response);
            }).catch((error) => reject(error));
        });
    }

    downloadArquivos(arquivos: {arquivoempresa: string}[]) {
        this.loading_deferred = this.$q.defer();
        return this.$q<File>((resolve, reject) => {
            this.$http.post<File>(
                this.nsjRouting.generate('meurh_arquivosempresas_downloadarquivoslote', {}, true), {
                    entities: angular.copy(arquivos)
                }, {
                responseType: 'blob',
                timeout: this.loading_deferred.promise
            })
            .then((response) => {
                this.$rootScope.$broadcast('meurh_arquivosempresas_downloadarquivoslote_loaded', response);
                resolve(response.data);
            })
            .catch((error) => reject(error));
        });
    }

    liberarArquivo(id: string) {
        this.loading_deferred = this.$q.defer();
        return this.$q<void>((resolve, reject) => {
            this.$http.post<void>(
                this.nsjRouting.generate('meurh_arquivosempresas_liberar', {
                    id
                }, true),
                { timeout: this.loading_deferred.promise }
            )
            .then((response) => {
                this.$rootScope.$broadcast('meurh_arquivosempresas_liberar_loaded', response.data);
                resolve(response.data);
            })
            .catch((error) => reject(error));
        });
    }
}
